interface TimeSpan {
    id: number;
    name: string;
    startHour: number;
    endHour: number;
}

//json with timespans of Ochtend (6u. - 9u.) / Voormiddag (9u. - 12u.) / Op de middag (12u. - 14u.) / Namiddag (14u. - 18u.) / Avond (18u. - 22u.) / Nacht (22u. - 06u.)
export const TimeSpans: TimeSpan[] = [
    {
        id: 1,
        name: 'Ochtend (6u. - 9u.)',
        startHour: 6,
        endHour: 9
    },
    {
        id: 2,
        name: 'Voormiddag (9u. - 12u.)',
        startHour: 9,
        endHour: 12
    },
    {
        id: 3,
        name: 'Op de middag (12u. - 14u.)',
        startHour: 12,
        endHour: 14
    },
    {
        id: 4,
        name: 'Namiddag (14u. - 18u.)',
        startHour: 14,
        endHour: 18
    },
    {
        id: 5,
        name: 'Avond (18u. - 22u.)',
        startHour: 18,
        endHour: 22
    },
    {
        id: 6,
        name: 'Nacht (22u. - 06u.)',
        startHour: 22,
        endHour: 6
    }
];

//function to get object from array of objects by id
export function getTimeSpanById(id: number): TimeSpan | undefined {
    return TimeSpans.find(x => x.id === id);
}

//# sourceMappingURL=timeSpans.js.map
